import React, { Component } from 'react';
import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import DispatchService from '../../services/DispatchService';
import { InputText } from 'primereact/inputtext';
import tableRequest from '../../models/tableRequest.js';
import { ConfirmationModal } from '../../template/ConfirmationModal';
import MessageComponent from '../../template/Message';
import Loaders from '../../template/Loaders';
import $ from 'jquery';


export default class DispatchReceive extends Component {
    constructor(props) {
        super(props);
        this.DispatchService = new DispatchService();
        this.tblResponse = new tableRequest();
        this.state = {
            DispatchId: "",

            globalFilter: null,
            visible: false,
            dispatchLoader: true,
            scanLoader: false,
            sortIcon: false,
            sortOrder: '1',
            formError: {
                DispatchId: ""
            },

            DispatchId: '',
            DeliveryOptions: [], // Initialize to an empty array
           
            buttonLabel: 'Submit',
            sales: [],
            selectedStatus: null,
            receive: [],
            getrow: [],
            newrow: [],
            scanItems: [],
            stateover: [],
            loading: true,
            first: 0,
            rows: 5,
            totalRecords: 0,
            globalFilter: null,
            emptyMessage: 'No Data found'
        }
        this.actionTemplate = this.actionTemplate.bind(this);
        this.activeTemplate = this.activeTemplate.bind(this);


        this.submitForm = this.submitForm.bind(this);
        this.SubmitReceive = this.SubmitReceive.bind(this);
        this.handleSelectionChange = this.handleSelectionChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.hideFunc = this.hideFunc.bind(this);
        this.onPage = this.onPage.bind(this);
        this.searchFilter = this.searchFilter.bind(this);
        this.openDialog = this.openDialog.bind(this);
        this.onSort = this.onSort.bind(this);
    }
    //trigger api function on page call
    componentDidMount() {
        setTimeout(() => {
            this.GetDispatchReceive();
            this.MigoDDl();
        }, 1000);

        $('.p-column-title').on('click', function () {
            $(this).next().removeClass('pi-sort').toggleClass('pi-sort-up').addClass('pi-sort-down');
        });

        console.log("stateover1 :- ", this.state.stateover);
    }

    // PAGE EVENT CALL
    onPage(event) {
        this.setState({
            loading: true
        });

        //imitate delay of a backend call
        setTimeout(() => {
            debugger

            this.getLazyLoadingValues(event);
            this.GetDispatchReceive();
            this.MigoDDl() 
            debugger

        }, 250);


    }
    handleSelectionChange = (e) => {
        this.setState({ selectedStatus: e.value }, () => {
            // Prepare the request body whenever the selection changes
            this.prepareRequestBody();
        });
    };
    
    prepareRequestBody = () => {
        const selectedIds = this.state.selectedStatus.map(item => ({ id: item.DeliveryId }));
        this.setState({ requestBody: { receive: selectedIds } });
    };
    // set lazy loading values
    getLazyLoadingValues(event) {
        this.setState({ rows: event.rows });
        this.tblResponse.PageSize = event.rows;
        this.tblResponse.First = event.first + 1;
        this.tblResponse.IsActive = true;
        this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
        //this.tblResponse.SortColumn = event.sortField;
        this.tblResponse.SortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
    }

    // get Dispatch Receive data list from api
    GetDispatchReceive() {
        debugger
        this.tblResponse.SortColumn = 'CreatedDt'
        this.tblResponse.WareHouseId = JSON.parse(sessionStorage.getItem("wareHouseId"));

        this.DispatchService.GetDispatchReceive(this.tblResponse).then(data => {
            this.setState({ scanLoader: true });

            const resdata = data.data;
            //if ResponseData not null
            if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                this.datasource = resdata.ResponseData;
                this.setState({
                    totalRecords: resdata.ResponseData[0].TotalRows,
                    first: (this.tblResponse.First - 1),
                    sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
                    loading: false
                });
            }
            //if ResponseData is null
            else {
                this.datasource = null;
                this.setState({
                    totalRecords: 0,
                    first: 1,
                    sales: null,
                    loading: false
                });
            }
        });
    }

    // get Dispatch Receive data list from api
    MigoDDl() {
        this.DispatchService.GetMigoDDL().then(data => {
            const resdata = data.data;
            if (resdata && resdata.ResponseData && resdata.ResponseData.length > 0) {
                const deliveries = resdata.ResponseData;
                const deliveryOptions = deliveries.map(delivery => ({
                    id: delivery.MigoNumber,  // Use MigoNumber as the identifier
                    name: delivery.MigoNumber, // Display name can also be MigoNumber
                }));
    
                this.setState({
                    DeliveryOptions: deliveryOptions,
                });
            }
        });
    }

    sendRequest = () => {
        const { requestBody } = this.state;
        
        // Make your API call here, assuming you have a service method to do so
        this.DispatchService.sendData(requestBody)
            .then(response => {
                console.log("Data sent successfully:", response);
            })
            .catch(error => {
                console.error("Error sending data:", error);
            });
    };

    handleCheckboxChange = event => {
        let newArray = [...this.state.receive, event.target.id];
        this.setState({
            receive: newArray
        });
    };

    // call every change of form and validation part also
    handleChange = (e) => {
        const selectedMigoNo = e.target.value;
        this.setState({ DispatchId: selectedMigoNo });

        // Call the API with the selected MigoNo
        if (selectedMigoNo) {
            this.GetMigoDetails(selectedMigoNo);
        }
    }

    // validate form
    validateForm(value, name) {
        let errors = this.state.formError;
        let IsValid = true;
        //to validate each form field with required conditions
        switch (name) {
            case 'DispatchId':
                if (value.length < 1) {
                    IsValid = false;
                    errors.DispatchId = "Please enter DispatchId.";
                }
                else if (!value.includes("DID")) {
                    IsValid = false;
                    errors.DispatchId = "Invalid DispatchId.";
                }
                else errors.DispatchId = ''
                break;

            default:
                break;
        }

        return IsValid;
    }

    // reset form text value
    formReset() {
        this.setState({
            DispatchId: "",


        });
        let errors = this.state.formError;
        Object.entries(errors).map(([key]) => {
            errors[key] = '';
        });
    }

    hideFunc() {
        this.setState({
            visible: false,
            buttonLabel: "Submit",
            formHeading: "Add Number Issue",
        });
        this.formReset();
    }

    // open Dialog
    openDialog() {
        this.setState({ visible: true });
        this.formReset();
    }

    // submit packing
    submitForm(e) {

        debugger;
        //   event.preventDefault(); 
        let isfrmvalid = true;
        let checkerror = this.state.formError;
        // this.setState({
        //     DispatchId : e.target.value
        // });

        Object.entries(checkerror).map(([key]) => {

            const val = this.state[key];
            let valid = this.validateForm(e.target.value, key);//KREP-59 defect
            //form is not valid
            if (!valid) {
                this.setState({ checkerror: isfrmvalid });
                isfrmvalid = false;
            }
        });



        //form is valid
        if (isfrmvalid) {
            const formData = {

                DispatchId: e.target.value,
            }




            setTimeout(() => {
                // this.DispatchService.SaveDispatchReceive(formData).then(data => {
                //     const resdata = data.data;
                //     if (resdata !== null && resdata.ResponseCode === '200') {

                //         this.refs.Messchild.showSuccess(resdata.ResponseMessage);

                //         this.setState({
                //             loading: true,
                //             visible: false
                //         });

                //        this.formReset();
                this.GetDispatchReceive();

                //     } else if (resdata.ResponseCode === '400') {
                //         this.refs.Messchild.showWarn(resdata.ResponseMessage);
                //     } else {
                //         this.refs.Messchild.showError(resdata.ResponseMessage);
                //     }
                // });
            }, 1000);


        }
    }


    // submit packing
    getDispatchCarton(e) {
        debugger
        if (e.key === 'Enter') {
            e.preventDefault();
            let isfrmvalid = true;
            let checkerror = this.state.formError;

            Object.entries(checkerror).map(([key]) => {
                const val = this.state[key];
                let valid = this.validateForm(e.target.value, key);//KREP-59 defect
                //form is not valid
                if (!valid) {
                    this.setState({ checkerror: isfrmvalid });
                    isfrmvalid = false;
                }
            });
            //form is valid
            if (isfrmvalid) {
                const formData = {
                    DispatchId: e.target.value,
                }
                const scanlist = this.state.scanItems;
                // if(this.state.scanItems.includes(formData.DispatchId))
                // {
                //    this.refs.Messchild.showWarn("Already added"); 
                // }

                const index = this.state.scanItems.findIndex((item) => item.DispatchId === formData.DispatchId)
                //const newArray = [...this.state.scanItems]
                if (index !== -1) {
                    // console.log("item exist");
                    // newArray.splice(index, 1, item)
                    this.refs.Messchild.showWarn("Already added");

                }
                else {



                    this.DispatchService.GetDispatchReceiveCarton(formData, scanlist).then(data => {
                        debugger

                        // this.setState({ dispatchLoader: true });
                        const resdata = data.data;
                        //if response data is not null success message will be shown else will move to 'else statement'
                        if (resdata.ResponseCode == "200" && resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
                            this.datasource = resdata.ResponseData;
                            var res = resdata.ResponseData[0];
                            this.setState({
                                carton: this.datasource,
                                loading: false
                            });
                            if (resdata.ResponseData[0].ResponseMessage != null) {
                                this.refs.Messchild.showSuccess(resdata.ResponseData[0].ResponseMessage);
                            }
                            else {

                            }
                            this.state.scanItems.push(res);
                            this.setState({
                                scanItems: this.state.scanItems,
                                scanTxt: "",

                            });
                        } else {
                            this.refs.Messchild.showWarn(resdata.ResponseMessage);
                            this.datasource = null;
                            this.setState({
                                carton: null,
                                loading: false
                            });
                        }
                    });
                }
            }
        }

    }


    // seach table
    searchFilter(e) {
        this.setState({
            loading: true
        });
        this.tblResponse.SearchValue = e.target.value;
        this.GetDispatchReceive();
    }

    callbackFunction = (childData) => {
        this.setState({ message: childData })
    }


    // add checkbox function
    activeTemplate(rowData, column) {

        return (
            <input type="checkbox" name={rowData.Id} onChange={e => { this.actionTemplate(e, rowData) }} />
        )
    }
    GetMigoDetails(MigoNo) {
        this.DispatchService.GetMigoDetails(MigoNo).then(data => {
            const resdata = data.data;
            if (resdata && Array.isArray(resdata.ResponseData)) {
                // Reset state before updating scanItems
                this.setState({
                    scanItems: resdata.ResponseData,
                    selectedStatus: [], // Clear selection
                    sortField: null,    // Reset sorting field
                    sortOrder: null,     // Reset sorting order
                });
            }
        }).catch(error => {
            console.error("Error fetching Migo details:", error);
        });
    }
    

    // edit form
    actionTemplate(e, rowData) {
        const getid = rowData.Id;
        this.state.newrow.push(getid);
        this.state.getrow.push({
            "id": rowData.Id
        })

    }
    sendRequest = () => {
        const { requestBody } = this.state;
        
        // Make your API call here, assuming you have a service method to do so
        this.YourApiService.sendData(requestBody)
            .then(response => {
                console.log("Data sent successfully:", response);
            })
            .catch(error => {
                console.error("Error sending data:", error);
            });
    };
    removeScanned() {
        debugger
        // let arrayfilter = this.state.scanItems.filter(
        //   (x) => x.DispatchId != DispatchId
        // );

        // this.setState({
        //   scanItems: arrayfilter,
        // });
        let arr = [this.state.scanItems];
        let arrr1 = arr[0];
        let values = [this.state.stateover];
        let values1 = values[0]
        //arr = arrr1.filter(item => !values1.includes(item));
        
        for (var obj in values1) {
                debugger
                arrr1 = arrr1.filter(p => values1[obj].id == p.Id)
               // arrr1 = arrr1.filter(item => values1.includes(item));
                
             }
             console.log(arrr1);
             this.setState({
          scanItems: arrr1,
        });
    }

    SubmitReceive() {
        debugger
        if (this.state.DispatchId == ""  && this.state.scanItems == "") {
            this.refs.Messchild.showWarn("Scan First");
        } 
        // else if(this.state.scanItems != "" && this.state.selectedStatus == null){
        //     this.refs.Messchild.showWarn("Please Select Checkbox Data");
        // }
        else {
        debugger
        this.setState({ dispatchLoader: false });
        if (this.state.selectedStatus == null) {
            this.refs.Messchild.showWarn("Please Select Checkbox Data");
            this.setState({ dispatchLoader: true });
        } else {


            const filterId = this.state.selectedStatus.filter(value => {
                this.state.stateover.push({ "id": value.Id });
            });

            debugger
            console.log("stateover :- ", this.state.stateover);
            //if stateover is not null else will move to 'else statement'
            if (this.state.stateover != null) {
                debugger
                this.DispatchService.DispatchCartonReceive(this.state.stateover).then(data => {
                    const resdata = data.data;
                    this.setState({ dispatchLoader: true });
                    if (resdata !== null && resdata.ResponseCode === '200') {
                        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                       // this.removeScanned(this.state.DispatchId)
                        // let arr = [this.state.scanItems];
                        //     let values = [this.state.stateover];
                            // arr = arr.filter(item => !values.includes(item.Id));
                            // console.log(arr);

                        // var tmp = [this.state.scanItems]
                        // var toRemove = [this.state.stateover[0]];
                        // var index = tmp[0]

                        // for (var obj in toRemove) {
                        //     debugger
                        //     index = index.filter(p => toRemove[obj].id == p.Id)
                        // }
                        // if (index > -1) { //Make sure item is present in the array, without if condition, -n indexes will be considered from the end of the array.
                        //     index.splice(index, 1);
                        // }
                        let scanItems = this.state.scanItems;
                         for (var i = 0; i < this.state.stateover.length; i++) { 
                            scanItems = scanItems.filter(scanItem => scanItem.Id !== this.state.stateover[i].id);
                         }
                        console.log('scanItems', scanItems);
                        this.setState({
                              scanItems: scanItems,
                              DispatchId:"",
                             });



                        this.GetDispatchReceive();
                    } else {
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                    }


                });

            }
            else {
                debugger

                this.DispatchService.DispatchCartonReceive(this.state.getrow).then(data => {
                    const resdata = data.data;
                    this.setState({ dispatchLoader: true });
                    if (resdata !== null && resdata.ResponseCode === '200') {
                        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
                    } else {
                        this.refs.Messchild.showWarn(resdata.ResponseMessage);
                    }
                });
            }
            // }
        }

    }
 }


    // Sort table
    onSort(event) {
        this.setState({
            sortOrder: this.state.sortOrder === 1 ? 2 : 1,
            sortIcon: !this.state.sortIcon
        });
        const sortField =
            event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
        this.tblResponse.SortColumn = sortField ? sortField : "";
        this.tblResponse.SortOrder = this.state.sortOrder === 1 ? 'DESC' : 'ASC';
        this.GetDispatchReceive();
        const clickData = document.getElementsByClassName(
            "p-sortable-column-icon pi pi-fw pi-sort"
        );
        console.log(event);
    }

    // create html part
    //resolved KREP-134,KREP-114(CR)
    render() {
        let header = (
            <div className="row">
                <div className="col-md-4 text-left">
                    <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                    {/* <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Global Search1" size="30" /> */}
                    <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="30" />
                </div>
            </div>
        );
        //console.log(this.state.selectedStatus);
        let subheader = (
            <div className="row">
            <div className="col-md-8 text-left">
                <form>
                    <div className="row">
                        <div className="col-md-2 text-left">Scan Item:</div>
                        <div className="col-md-6">
                            <select 
                                value={this.state.DispatchId} 
                                onChange={this.handleChange} 
                                className="custom-input" 
                                name="DispatchId"
                            >
                                <option value="">Select an item</option>
                                {this.state.DeliveryOptions.map(option => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                            {this.state.formError.DispatchId !== null ? (
                                <div className='error'>{this.state.formError.DispatchId}</div>
                            ) : null}
                        </div>
                    </div>
                </form>
            </div>
                <div className="col-md-4 text-right">
                    <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
                    <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Global Search2" size="30" />

                </div>
            </div>
        );


        return (
            <>
                <MessageComponent ref="Messchild" />
                <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />


                <div className="heading mb-2">
                    <h1>Dispatch Receive</h1>
                </div>

                <Loaders loader={this.state.scanLoader} classType="small" />
                <DataTable responsive={true} header={header} globalFilter={this.state.globalFilter}
                    emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true}
                    rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]}
                    totalRecords={this.state.totalRecords} lazy={true} first={this.state.first}
                    onPage={this.onPage} onSort={this.onSort} className="tblAuto">
                    <Column field="DispatchId" header="Dispatch Id" sortable={true} />
                    <Column field="DeliveryNo" header="Delivery No" sortable={true} />
                    <Column field="MigoNumber" header="Migo Number" sortable={true} />
                    <Column field="CreatedDt" header="Date" sortable={true} />
                    <Column field="TotalTertiaryCarton" header="Total Carton" sortable="custom" />
                    <Column field="Status" header="Status" sortable={true} />
                </DataTable>
                <div className="heading mb-1 mt-3">
                    <h1>Carton List</h1>
                </div>
                <Loaders loader={this.state.dispatchLoader} classType="small" />
                <DataTable  
    selection={this.state.selectedStatus} 
    onSelectionChange={this.handleSelectionChange} 
    responsive={true} 
    key={this.state.scanItems.length}
    header={subheader}
    emptyMessage={this.state.emptyMessage} 
    value={this.state.scanItems} 
    rows={this.state.rows} 
    rowsPerPageOptions={[5, 10, 20]}
    lazy={true}
    onPage={this.onPage} 
    onSort={(e) => this.setState({ sortField: e.sortField, sortOrder: e.sortOrder })}
    className="tblAuto"
>
    <Column field="DeliveryId" header="Delivery Id" sortable={true} />
    <Column field="DeliveryNo" header="Delivery No" sortable={true} />
    <Column field="MaterialCode" header="Material Code" sortable={true} />
    <Column field="MaterialDescription" header="Material Description" sortable={true} />
    <Column field="Qty" header="Quantity" sortable={true} />
    <Column selectionMode="multiple" header="Select all" headerStyle={{ width: '3rem' }} />
</DataTable>

                <div className="col-md-12 mt-3 text-center">
                    <button type="submit" onClick={this.SubmitReceive} className="btn btn-primary">
                        Receive
                    </button>
                </div>

            </>
        )
    }
}